export { default } from "./prevent-clicking-mask";
